module.exports = __webpack_public_path__ + "img/sleep_tag2.b6d29e71.png";